import { collection, addDoc, serverTimestamp, doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { logEvent } from 'firebase/analytics';
import { db, storage, analytics } from '../firebase';

export const createLogEntry = async (params: {
    userId: string;
    type: string;
    description: string;
    plantId?: string;
    seedId?: string | null;
    createdAt?: Date;
}): Promise<void> => {
    const { createdAt, ...rest } = params;
    const docRef = await addDoc(collection(db, 'log_events'), {
        ...rest,
        createdAt: createdAt || new Date(),
    });
    logEvent(analytics, 'log_entry_created', { entry_id: docRef.id, type: params.type });
};

export const createManualLogEntry = async (
    userId: string,
    description: string,
    photoFile?: File
): Promise<void> => {
    let logImageUrl = '';

    if (photoFile) {
        const timestamp = Date.now();
        const fileName = `log_events/${userId}/${timestamp}_${photoFile.name}`;
        const storageRef = ref(storage, fileName);
        await uploadBytes(storageRef, photoFile);
        logImageUrl = await getDownloadURL(storageRef);
    }

    const logEntry: any = {
        userId,
        type: 'manual',
        description,
        isManual: true,
        createdAt: new Date(),
    };

    if (logImageUrl) {
        logEntry.logImageUrl = logImageUrl;
    }

    // Use addDoc to let Firestore generate the ID
    const docRef = await addDoc(collection(db, 'log_events'), {
        ...logEntry,
        createdAt: serverTimestamp(),
    });
    logEvent(analytics, 'log_entry_created', { entry_id: docRef.id, type: 'manual' });
};

export const updateManualLogEntry = async (
    eventId: string,
    userId: string,
    description: string,
    photoFile?: File
): Promise<void> => {
    let logImageUrl = '';

    if (photoFile) {
        const timestamp = Date.now();
        const fileName = `log_events/${userId}/${timestamp}_${photoFile.name}`;
        const storageRef = ref(storage, fileName);
        await uploadBytes(storageRef, photoFile);
        logImageUrl = await getDownloadURL(storageRef);
    }

    const updates: any = {
        description,
        updatedAt: serverTimestamp(),
    };

    if (logImageUrl) {
        updates.logImageUrl = logImageUrl;
    }

    const eventRef = doc(db, 'log_events', eventId);
    await updateDoc(eventRef, updates);
    logEvent(analytics, 'log_entry_updated', { entry_id: eventId });
};

export const deleteManualLogEntry = async (eventId: string): Promise<void> => {
    const eventRef = doc(db, 'log_events', eventId);
    await deleteDoc(eventRef);
    logEvent(analytics, 'log_entry_deleted', { entry_id: eventId });
};
